/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

export interface TdRowProps {
  /**
   * 列之间的间距（默认单位px）
   */
  gutter?: {
    type: null;
    value?: string | number;
  };
}
